export default function Home() {
    return (
        <>
            <h2>Drippy Rugs</h2>
            <p>Ahoj,</p>
            <p>
                Vítej na mých stránkách, na kterých jsem sepsal všechny důležité
                informace, které by se ti mohly hodit při výběru vlastního
                koberečku.
            </p>

            <h3>Pár slov o mně:</h3>
            <p>
                Dlouhou dobu jsem hledal něco, co by mě mohlo bavit a zároveň i
                něco přivydělat. Postupně jsem zkoušel různé možnosti jak k tomu
                dospět, ale jednoho dne jsem narazil na tento začínající trend z
                Ameriky. Z videí na tiktoku a instagramu jsem byl fascinován
                tím, jakým způsobem se koberečky vyrábí a téměř bez rozmyslu
                jsem začal shánět věci a informace k tomu, abych si svůj
                kobereček mohl také sám vyrobit.
            </p>
            <p>
                V roce 2021 jsem tedy vyrobil svůj první kobereček. Nebylo to
                teda nic moc, ale práce s mašinkou mě neskutečně bavila a tak
                jsem pokračoval dál ve svém zdokonalování. První kusy jsem
                zkusil nahrát na platformu Vinted a ty se ihned prodaly. Reakce
                lidí byly jen pozitivní a já si začínal uvědomovat, že se někomu
                má práce líbí.
            </p>
            <p>
                Proto jsem založil instagram a začal budovat značku. Od té doby
                se pořád snažím posouvat kvalitu vpřed. Myslím že když se
                ohlédnu zpět na své první koberečky a na koberečky z poslední
                doby, pokrok je opravdu znatelný, byť ještě nejsem spokojený na
                100%.
            </p>
            <p>
                Do budoucna mám se značkou plány na rozšíření své nabídky a
                produktů. Takže pokud na té cestě chceš být se mnou, nebo mi
                nabídnout spolupráci, která by dávala smysl, určitě to spolu
                můžeme probrat.
            </p>
        </>
    )
}
